import { SortQueryDirection } from "@ds-cps/ui";

import { FilterOptions, SortByForResources } from "./models";

export class CreateParamsForResources extends URLSearchParams {
  withPagination(pageSize: number, pageIndex?: number) {
    this.append("pageSize", pageSize.toString());

    if (pageIndex !== undefined) {
      this.append("offset", (pageIndex * pageSize).toString());
    }
  }

  withSortBy(activeSort: string) {
    const sortMap: Record<string, string> = {
      "serial-number": SortByForResources.SerialNumber,
      "resource-type": SortByForResources.ResourceType,
      "product-family-name": SortByForResources.ProductFamilyName,
      "relationship-type": SortByForResources.RelationshipType
    };

    if (sortMap[activeSort]) {
      this.append("sortBy", `${sortMap[activeSort]}`);
    }
  }

  withSortDirection(sortDirection: SortQueryDirection) {
    if (sortDirection) {
      this.append("sortDirection", `${sortDirection}`);
    }
  }

  withFilterOptions(filterOptions?: FilterOptions) {
    if (filterOptions) {
      const {
        serialNumbers,
        productFamilyName,
        resourceType,
        entityId,
        entityType,
        relationshipType
      } = filterOptions;

      if (serialNumbers && serialNumbers?.length > 0) {
        // Backend supports ?SerialNumbers=firstItem,anotherItem,oneMoreItem
        this.append("serialNumbers", serialNumbers?.join(","));
      }

      if (resourceType) {
        this.append("resourceType", resourceType);
      }

      // productFamilyName value can be valid string or "-"
      if (productFamilyName) {
        this.append("productFamilyName", productFamilyName);
      }

      if (entityId) {
        this.append("entityId", entityId);
      }

      if (entityType) {
        this.append("entityType", entityType);
      }

      if (relationshipType) {
        this.append("relationshipType", relationshipType);
      }
    }
  }
}
